import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Compare = createSvgIcon(
  <path d="m4.616 5.625 4.36-3.93L7.47.024.007 6.75l7.463 6.726 1.506-1.67-4.36-3.93H18v-2.25H4.616Zm14.768 10.5-4.36-3.93 1.506-1.671 7.463 6.726-7.463 6.727-1.506-1.672 4.36-3.93H5.25v-2.25h14.134Z" />,
  'Compare'
);

export { Compare };